import { observable, computed } from "mobx";

import Node from "./Node";
import Discovery from "./Discovery";

export default class Movie {
  store;

  @observable title;
  @observable assets;
  @observable startNodeId;
  @observable nodes;
  @observable discoveries;

  @computed
  get totalChapters() {
    return Object.keys(this.nodes).length;
  }

  @computed
  get completedChapters() {
    return Object.keys(this.nodes)
      .map(x => this.nodes[x])
      .filter(node => node.isComplete).length;
  }

  @computed
  get remainingChapters() {
    return this.totalChapters - this.completedChapters;
  }

  @computed
  get totalDiscoveries() {
    return Object.keys(this.discoveries).length;
  }

  @computed
  get completedDiscoveries() {
    const { discoveries } = this.store.session;
    return Object.keys(discoveries)
      .map(x => discoveries[x])
      .filter(x => x.visited).length;
  }

  @computed
  get remainingDiscoveries() {
    return this.totalDiscoveries - this.completedDiscoveries;
  }

  @computed
  get startNode() {
    return this.nodes[this.startNodeId];
  }

  @computed
  get shouldShowEndOfPath() {
    return !Object.keys(this.nodes).some(id => {
      const node = this.nodes[id];
      return node.links.length === 0 && node.isComplete;
    });
  }

  @computed
  get nodeToParents() {
    const result = {};

    Object.keys(this.nodes).forEach(id => {
      const node = this.nodes[id];

      node.links.forEach(({ destination }) => {
        result[destination] = result[destination] || [];
        result[destination].push(node);
      });
    });

    return result;
  }

  @computed
  get nodeToDiscoveries() {
    const result = {};

    Object.keys(this.discoveries).forEach(id => {
      const discovery = this.discoveries[id];
      const { nodes } = discovery;
      Object.keys(nodes).forEach(nodeId => {
        const node = nodes[nodeId];
        result[nodeId] = result[nodeId] || [];
        discovery.time = node.time;

        result[nodeId].push(discovery);
      });
    });

    return result;
  }

  constructor(store, data) {
    this.store = store;

    this.title = data.title;
    this.startNodeId = data.startNode;

    this.assets = Object.keys(data.assets).reduce((result, id) => {
      result[id] = data.assets[id];
      return result;
    }, {});
    this.discoveries = data.discoveries.reduce((result, discovery) => {
      result[discovery._id] = new Discovery(this.store, discovery);
      return result;
    }, {});
    this.nodes = Object.keys(data.nodes).reduce((result, id) => {
      result[id] = new Node(this.store, data.nodes[id]);
      return result;
    }, {});
  }
}



// WEBPACK FOOTER //
// ./src/models/Movie.js